import { useState, React } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { Toaster, toast } from 'react-hot-toast';
import { submitContactDetailsAction } from '../../apis/apiAction';

const ModalDeck = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    Name: '',
    email: '',
  });

  const inputHandler = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const isValidate = () => {
    if (!formData.email) {
      toast.error('Email is required');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Enter a valid email');
      return false;
    }
    return true;
  };

  const submitContactDetails = async () => {
    if (!isValidate()) return;
    try {
      let res = await submitContactDetailsAction(formData);
      if (res.status) {
        toast.success('You are Subscribed!!');
        if (onSuccess) {
          onSuccess();
        }
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <>
      <Form>
        <Row>
          <Col lg={12}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                Name <span className="redStar">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Name"
                name="Name"
                value={formData.Name}
                onChange={inputHandler}
              />
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                Email Address <span className="redStar">*</span>
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email"
                value={formData.email}
                onChange={inputHandler}
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="text-center">
          <Button variant="primary" onClick={submitContactDetails}>
            Proceed
          </Button>
        </div>
      </Form>
    </>
  );
};
export default ModalDeck;
